import loadable from "@loadable/component";
import ReceiveManifestIcon from "../../Icons/ReceiveManifestIcon";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import { queryClient } from "../../router/CourierReceiveManifestRouter";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const ReceiveManifestListComponent = loadable(
  () => import("../../components/CourierReceiveManifest/ReceiveManifestList")
);

const ReceiveManifestlist = () => {
  const { data: profile, isLoading } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });
  const { mutateAsync: checkConsignmentsMutateAsync } = usePostHook({
    queryKey: ["received-manifest-items"],
  });

  const handlecheckConsignments = async (
    consignmentId: string,
    setError: any
  ) => {
    const url = `${APIS.MANIFEST}receive-order/`;
    let formData = {
      tracking_number: consignmentId,
    };
    try {
      const res = await checkConsignmentsMutateAsync({
        url,
        formData,
        setError,
      });
      if (res?.status === 200) {
        queryClient.refetchQueries();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <ReceiveManifestIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Receive Manifest
        </span>
      </div>
      <ReceiveManifestListComponent
        defaultBranch={profile?.default_branch}
        handlecheckConsignments={handlecheckConsignments}
      />
    </>
  );
};

export default ReceiveManifestlist;
